import type {AssignPermissionToRoleFormPayload} from "./assign-permission-to-role.schema";
import {assignAccessAdministrationRolePermission} from "@project/sdk/access-administration";
import {AssignAccessAdministrationRolePermissionResponse} from "@project/sdk/access-administration/zod";
import {mutationOptions} from "@tanstack/react-query";
import {
  accessAdministrationMutationKeys,
  roleKeys,
  userAccessKeys,
} from "../../access-administration-keys";

export function assignPermissionToRoleMutationOptions(roleId: string) {
  return mutationOptions({
    mutationKey: accessAdministrationMutationKeys.assignPermissionToRole,
    mutationFn: async (payload: AssignPermissionToRoleFormPayload) =>
      AssignAccessAdministrationRolePermissionResponse.parse(
        await assignAccessAdministrationRolePermission(roleId, payload),
      ),
    onSuccess: async (_data, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: roleKeys.all}),
        client.invalidateQueries({queryKey: userAccessKeys.all}),
      ]);
    },
  });
}
